import React, { useEffect } from 'react';
import { StyledPurchaseContainer } from './Styles';
import { getCookie } from '../../_shared/utils/cookies';
import { COOKIES } from '../../_shared/constants/cookies';
import { COUNTRY } from '../../_shared/constants/country';
import { sessionStorageService } from '../../services/StorageService';
import NavSecondary from '../../components/NavSecondary';
import OktaAuthManagementService from '../../services/OktaAuthManagementService';
import useCurrentTradeState from '../../_shared/hooks/trade/useCurrentTradeState';

const Purchase = () => {
  const tradeState = useCurrentTradeState();

  if (
    process.env.REACT_APP_PURCHASES_COMPONENT_HOST &&
    !document.getElementById('purchase-component-script')
  ) {
    const script = document.createElement('script');
    script.src = `${
      process.env.REACT_APP_PURCHASES_COMPONENT_HOST
    }?${+new Date()}`;
    script.type = 'text/javascript';
    script.id = 'purchase-component-script';
    document.head.appendChild(script);
  }

  const oktaService = OktaAuthManagementService.get();

  useEffect(() => {
    async function initiate() {
      await oktaService.initiateOktaSession();
      setTimeout(() => {
        sessionStorageService.setItem('nw_auth', 'complete');
        document.dispatchEvent(new CustomEvent('nw_auth'));
      }, 500);
    }
    initiate();
  }, [oktaService]);

  const csuAuctionAccessIds = getCookie(COOKIES.CSU_AUCTION_ACCESS_IDS);
  const csuEcsIds = getCookie(COOKIES.CSU_ECS_IDS);

  return (
    <>
      <NavSecondary tradeState={tradeState} />
      <StyledPurchaseContainer>
        <nw-purchases
          region={COUNTRY.CA}
          override-org-auction-access-ids={csuAuctionAccessIds}
          override-org-ecs-ids={csuEcsIds}
          disable-plaid-enrollment={null}
          theme="traderev"
        />
      </StyledPurchaseContainer>
    </>
  );
};

export default Purchase;
